import { createContext, useContext } from "react"

type DashboardContextType = {
  setFlushContent: (flush: boolean) => void
}

export const DashboardContext = createContext<DashboardContextType>({
  setFlushContent: () => {},
})

export const useDashboard = () => useContext(DashboardContext)
